import { styled } from '@volkswagen-onehub/components-core';

interface StyledLimitContentProps {
  maxLines: number;
}

export const StyledLimitContent = styled.span<StyledLimitContentProps>(
  ({ maxLines }) => `
    display: -webkit-box;
    line-clamp: ${maxLines};
    -webkit-line-clamp: ${maxLines};
    box-orient: vertical;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    `
);
